export default "__VITE_PUBLIC_ASSET__853ff1ef__"